import type { ProductAPI } from './Catalog';
import { ENDPOINT } from './constants';
import { RequestAPI } from './Requests';
import { getLangHeaders } from './utils';

export interface FavoritesResponse {
  data: ProductAPI[];
  pagination: {
    total: number;
    page: number;
    size: number;
  };
}

interface PurchasedResponse {
  data: ProductAPI[];
  pagination: {
    total: number;
    page: number;
    size: number;
  };
}

interface FavoritesRequestsInterface {
  getFavorites(data: {
    warehouseCode?: string;
    isSafeRequest?: boolean;
    page: {
      size: number;
      current: number;
    };
  }): Promise<FavoritesResponse>;

  getFavoritesIds(): Promise<{ data: number[] }>;

  addManyFavorites(data: { ids: number[] }): Promise<void>;

  removeFavorite(id: number): Promise<void>;

  getPurchasedItems(data: {
    warehouseCode?: string;
    page: number;
    limit: number;
  }): Promise<PurchasedResponse>;
}

export const FavoritesRequest: FavoritesRequestsInterface = {
  getFavorites: (data) =>
    RequestAPI.get(ENDPOINT.favorites.get, data, getLangHeaders()),

  getFavoritesIds: () =>
    RequestAPI.get(ENDPOINT.favorites.getIds, {}, getLangHeaders()),

  addManyFavorites: (data) =>
    RequestAPI.post(ENDPOINT.favorites.addMany, data, getLangHeaders()),

  removeFavorite: (id) => RequestAPI.delete(ENDPOINT.favorites.remove + id),

  getPurchasedItems: ({ warehouseCode, page, limit }) =>
    RequestAPI.get(
      ENDPOINT.orders.boughtItems,
      {
        ...(warehouseCode ? { warehouse_code: warehouseCode } : {}),
        page,
        limit,
      },
      getLangHeaders(),
    ),
};
